/* @flow */

import type {
  CmsBlock,
} from "shop-state/types";

import type { Model, EffectErrorMessage } from "crustate";
import type { Response } from "./util";
import { updateData, updateNone, EFFECT_ERROR } from "crustate";

type Data =
  | { state: "INIT" }
  | { state: "LOADING" }
  | { state: "LOADED", data: CmsBlock | null };

export type CmsBlockResponse =
  Response<typeof CMS_BLOCK_RESPONSE, ?CmsBlock> | EffectErrorMessage;

export type CmsBlockRequest = {
  tag: typeof CMS_BLOCK_REQUEST,
  identifier: string,
};

export const CMS_BLOCK_RESPONSE: "response/cms-block" = "response/cms-block";
export const CMS_BLOCK_REQUEST: "request/cms-block" = "request/cms-block";

export const load = (identifier: string): CmsBlockRequest => {
  return {
    tag: CMS_BLOCK_REQUEST,
    identifier,
  };
};

export const CmsBlockModel: Model<Data, {
  identifier: string,
}, CmsBlockRequest | CmsBlockResponse> = {
  id: "cms-block",
  init: ({ identifier }) =>
    updateData(
      { state: "LOADING" },
      load(identifier)
    ),
  update: (state: Data, msg) => {
    switch (msg.tag) {
      case EFFECT_ERROR:
        throw new Error("Cms-block effect error");
      case CMS_BLOCK_RESPONSE:
        if (state.state === "LOADING") {
          return updateData({
            state: "LOADED",
            data: msg.data ? msg.data : null,
          });
        }

        return updateNone();
      default:
    }
  },
};
